import { ContentCopy } from '@mui/icons-material';
import {
  IconButton,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CopyTextType = {
  copyIconSize?: number;
} & TypographyProps;

export const CopyText = ({
  copyIconSize = 14,
  children,
  ...rest
}: CopyTextType) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const ref = useRef<HTMLElement>();

  const handleCopyToClipboard = e => {
    const textToCopy = ref.current?.innerText.trim();
    navigator.clipboard.writeText(textToCopy);
    setIsCopied(true);
    e.stopPropagation();
  };

  const handleResetTooltipValue = () => {
    setTimeout(() => setIsCopied(false), 100);
  };

  return (
    <Typography ref={ref}>
      {children}{' '}
      {!!children && (
        <Tooltip
          title={
            isCopied
              ? t('CopyText.tooltip.afterCopy')
              : t('CopyText.tooltip.beforeCopy')
          }
          // @ts-ignore
          PopperProps={{ 'data-testid': 'CopyText.Tooltip' }}
          onClose={handleResetTooltipValue}
        >
          <IconButton
            color="primary"
            onClick={handleCopyToClipboard}
            data-testid="CopyText.button"
          >
            <ContentCopy
              sx={{
                cursor: 'pointer',
                fontSize: copyIconSize,
              }}
            />
          </IconButton>
        </Tooltip>
      )}
    </Typography>
  );
};

export default CopyText;
